import "react-table/react-table.css";

import "./ActiveChannels.scss";

import iso from "iso-3166-1";
import groupBy from "lodash.groupby";
import { DateTime } from "luxon";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";

import { getActiveChannels } from "../selectors/channel";
import { costPerConditionsDatapoint } from "../weathersv";

const monthsToHours = (months) => months * 31 * 24;

const buildCountryList = (byCountry) => {
  return Object.keys(byCountry).map((country) => ({
    location: { country },
    channels: byCountry[country],
  }));
};

const countryColumn = (short) => {
  return {
    Header: "Country",
    id: "country",
    ...(short && { maxWidth: 300 }),
    accessor: (c) => {
      const country = iso.whereAlpha2(c.location.country);
      return short ? country.alpha3 : country.country;
    },
  };
};

class ActiveChannels extends Component {
  constructor(props) {
    super(props);

    this.state = {
      view: "remaining",
      country: null,
      selectedForTopup: [],
      topupMonths: 1,
    };
  }

  setView = (view) => {
    this.setState({ view, country: null });
  };

  selectCountry = (country) => {
    this.setState({ country });
  };

  selectChannel = (channel) => {
    this.props.history.push(`/channel/${channel}`);
  };

  purchaseTopup = async () => {
    const quantity = monthsToHours(this.state.topupMonths).toString();

    const items = this.state.selectedForTopup.map((channel) => ({
      productId: "TOPUP_CONDITIONS",
      quantity,
      data: { channelId: channel.id },
    }));

    const orderResponse = await fetch("/api/orders", {
      credentials: "include",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items,
      }),
    });

    if (!orderResponse.ok) {
      if (orderResponse.status === 401) {
        // redirect to login
        window.location.href = `${
          window.location.origin
        }/login?ref=${encodeURIComponent(window.location.pathname)}`;
      }
      // TODO: display error
      return;
    }

    const order = await orderResponse.json();

    window.location.href = `${window.location.origin}/orders/${order.id}`;
  };

  handleToggleSelectForTopup = (channel) => {
    this.setState((state) => {
      if (state.selectedForTopup.includes(channel))
        return {
          paymentReceived: false,
          selectedForTopup: state.selectedForTopup.filter(
            (s) => s.id !== channel.id
          ),
        };
      else
        return {
          paymentReceived: false,
          selectedForTopup: state.selectedForTopup.concat(channel),
        };
    });
  };

  handleChangeTopupMonths = (event) => {
    this.setState({ paymentReceived: false, topupMonths: event.target.value });
  };

  render() {
    const { country, view, selectedForTopup, topupMonths } = this.state;
    let { channels } = this.props;
    let countryList = null;

    if (country || view === "country") {
      const byCountry = groupBy(
        channels,
        (channel) => channel.location.country
      );

      if (country) channels = byCountry[country];
      if (view === "country") countryList = buildCountryList(byCountry);
    }

    let total = 0;
    if (selectedForTopup.length) {
      total =
        costPerConditionsDatapoint *
        monthsToHours(topupMonths) *
        selectedForTopup.length;
    }

    const now = DateTime.utc();

    return (
      <div>
        <h1>Channels {country && " - " + iso.whereAlpha2(country).country}</h1>
        <div style={{ textAlign: "right" }}>
          <div
            className={
              "toggle " +
              (view === "country" && !country ? "active" : "inactive")
            }
            onClick={() => this.setView("country")}
          >
            Countries
          </div>
          <div
            className={
              "toggle " + (view === "remaining" ? "active" : "inactive")
            }
            onClick={() => this.setView("remaining")}
          >
            All
          </div>
        </div>
        {(view === "remaining" || country) && (
          <ReactTable
            data={channels}
            columns={[
              {
                Header: "Channel",
                accessor: "location.name",
              },
              ...(country ? [] : [countryColumn(true)]),
              {
                Header: "Days Remaining",
                id: "balance",
                accessor: (c) => {
                  if (c.status.active_until) {
                    return Math.round(
                      Math.max(
                        0,
                        DateTime.fromISO(c.status.active_until)
                          .diff(now)
                          .as("days")
                      )
                    );
                  }

                  return 0;
                },
                maxWidth: 300,
              },
              {
                Header: "Top Up",
                id: "topup",
                minWidth: 60,
                Cell: (row) => {
                  return (
                    <div>
                      <input
                        type="checkbox"
                        checked={
                          selectedForTopup.find(
                            (x) => x.id === row.original.id
                          ) !== undefined
                        }
                        onClick={(event) => event.stopPropagation()}
                        onChange={() =>
                          this.handleToggleSelectForTopup(row.original)
                        }
                      />
                    </div>
                  );
                },
              },
            ]}
            defaultSorted={[{ id: "balance", desc: false }]}
            getTdProps={(state, rowInfo, column) => ({
              onClick: (e, handleOriginal) => {
                if (column.Header === "Channel") {
                  this.selectChannel(rowInfo.original.id);
                }
                if (handleOriginal) handleOriginal();
              },
            })}
          />
        )}
        {view === "country" && !country && (
          <ReactTable
            data={countryList}
            columns={[
              countryColumn(false),
              {
                Header: "Activated Channels",
                id: "numChannels",
                accessor: (c) => c.channels.length,
              },
            ]}
            defaultSorted={[{ id: "numChannels", desc: true }]}
            getTrProps={(state, rowInfo, column) => ({
              onClick: (e, handleOriginal) => {
                this.selectCountry(rowInfo.original.location.country);

                if (handleOriginal) handleOriginal();
              },
            })}
          />
        )}
        {selectedForTopup.length > 0 && (
          <div className="payment-preview">
            <h3>Top Up Channels</h3>
            <div className="info">
              Fund {selectedForTopup.length} channels for
              <label className="item">
                <input
                  type="number"
                  min="1"
                  step="1"
                  value={topupMonths}
                  name="months"
                  onChange={this.handleChangeTopupMonths}
                />
                months
              </label>
              {(total / 100000000).toFixed(4)} BSV
              <div className="btn primary item" onClick={this.purchaseTopup}>
                Pay Now
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(
  connect((state, props) => ({
    channels: getActiveChannels(state, props),
    settings: state.settings,
  }))(ActiveChannels)
);
